import React from 'react';
import { Card } from '../ui/card';
import { cn } from '../../lib/utils';

const AdminCard = ({ className, children }) => {
  return (
    <Card className={cn('overflow-hidden relative transition-all duration-200 bg-slate-900/60 border-slate-700 hover:shadow-xl hover:border-slate-600', className)}>
      {children}
    </Card>
  );
};

export default AdminCard;
export { AdminCard };
